import './timeline.scss';
import Swiper from 'swiper';
import { A11y, Navigation, Keyboard } from 'swiper/modules';

class Timeline {
    constructor ($timeline) {
        this.$timeline = $timeline;

        this.$slider = this.$timeline.querySelector('[data-timeline="slides"]');
        this.$activeYears = this.$timeline.querySelector('[data-timeline="activeYears"]');
        this.$years = this.$timeline.querySelectorAll('[data-timeline-year]');
        this.slider = undefined;
    }

    initialize () {
        if (this.$slider) {
            this.initSlider();
            this.loadYears();
            this.resizeTimeline();
        }
    }

    loadYears () {
        let yearsHtml = '';

        if (this.$years.length > 1) {
            this.$years.forEach(year => {
                yearsHtml += `<div class="timeline__entry"><span data-timeline="activeYear" data-timeline-active-year="${year.dataset.timelineYear}">${year.dataset.timelineYear}</span></div>`;
            });

            this.$activeYears.innerHTML = yearsHtml;
            this.updateActiveYear();

            this.$timeline.querySelectorAll('[data-timeline="activeYear"]').forEach($yearElement => {
                $yearElement.addEventListener('click', () => {
                    const year = $yearElement.dataset.timelineActiveYear;
                    const index = Array.from(this.$years).findIndex(yearElement => yearElement.dataset.timelineYear === year);
                    this.slider.slideTo(index);
                });
            });
        }
    }

    updateActiveYear () {
        const activeSlide = this.slider.slides[this.slider.activeIndex];
        const activeYear = activeSlide.dataset.timelineYear;
        const $activeYearElement = this.$timeline.querySelector(`[data-timeline-active-year="${activeYear}"]`);

        this.$timeline.querySelectorAll('[data-timeline="activeYear"]').forEach($yearElement => {
            if ($yearElement.dataset.timelineActiveYear === activeYear) {
                $yearElement.classList.add('is--active');
            } else {
                $yearElement.classList.remove('is--active');
            }
        });

        if ($activeYearElement) {
            const containerRect = this.$activeYears.getBoundingClientRect();
            const yearRect = $activeYearElement.getBoundingClientRect();

            if (yearRect.left < containerRect.left) {
                this.$activeYears.scrollLeft -= containerRect.left - yearRect.left + 50;
            } else if (yearRect.right > containerRect.right) {
                this.$activeYears.scrollLeft += yearRect.right - containerRect.right + 50;
            }
        }
    }

    resizeTimeline () {
        const checkIfScrollable = () => {
            const isScrollable = this.$activeYears.scrollWidth > this.$activeYears.clientWidth;

            if (isScrollable) {
                this.$timeline.classList.add('is--scrollable');
            } else {
                this.$timeline.classList.remove('is--scrollable');
            }
        };

        // Initial call to checkIfScrollable
        checkIfScrollable();

        // Recall checkIfScrollable on window resize
        window.addEventListener('resize', () => {
            setTimeout(() => {
                checkIfScrollable();
            }, 100);
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [A11y, Navigation, Keyboard],
            a11y: true,
            keyboard: true,
            slidesPerView: 'auto',
            resistanceRatio: 0,
            centeredSlides: true,
            spaceBetween: 24,
            navigation: {
                prevEl: this.$timeline.querySelector('[data-timeline="prev"]'),
                nextEl: this.$timeline.querySelector('[data-timeline="next"]')
            },
            breakpointsInverse: true,
            breakpoints: {
                1024: {
                    spaceBetween: 40
                },
                1440: {
                    spaceBetween: 60
                }
            },
            on: {
                slideChange: () => {
                    this.updateActiveYear();
                }
            }
        });
    }
}

export { Timeline };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-timeline="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new Timeline($root);
            $rootAPI.initialize();
        });
    }
});
